module.exports = __webpack_public_path__ + "assets/icons/ic_card_view.svg";